export const ROUTE_NAMES = {
  HOME: '/',
  ABOUT_US: '/about-us',
  SERVISES: '/services',
  SERVISE: `/services/:id`,
  FEEDBACK: '/feedback'
}

export const LINKS = {
  INSTAGRAM: 'https://www.instagram.com/techproengineering/',
  FACEBOOK: 'https://www.facebook.com/techproengineering/',
}

export const EMAIL_CONFIG = {
  PUBLIC_KEY: 'fHYoWtApHtV9w8Upq',
  SERVICE_ID: 'service_1099hky',
  TEMPLATE_ID: 'template_bnxpn1g'
}
